import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect y={4} width={32} height={24} rx={4} fill="white" />
    <rect
      x={0.5}
      y={4.5}
      width={31}
      height={23}
      rx={3.5}
      stroke="#161C24"
      strokeOpacity={0.1}
    />
    <path
      d="M19.5047 15.9861C19.5031 15.0473 19.215 14.131 18.6783 13.3577C18.1417 12.5844 17.3815 11.9902 16.4979 11.6533V20.3188C17.3818 19.9824 18.1423 19.3883 18.679 18.6149C19.2158 17.8415 19.5037 16.9249 19.5047 15.9861ZM13.1456 20.3173V11.6541C12.2625 11.9913 11.503 12.5855 10.9667 13.3587C10.4305 14.1318 10.1427 15.0477 10.1411 15.9861C10.1428 16.9243 10.4307 17.84 10.967 18.613C11.5032 19.386 12.2627 19.9801 13.1456 20.3173ZM14.8225 8.66171C12.8636 8.66192 10.985 9.43368 9.59995 10.8072C8.21487 12.1808 7.43675 14.0437 7.43675 15.9861C7.43695 17.9281 8.21511 19.7905 9.60004 21.1636C10.985 22.5367 12.8633 23.3081 14.8217 23.3081C15.7916 23.3082 16.7519 23.1189 17.6479 22.751C18.544 22.3831 19.3581 21.8438 20.044 21.1639C20.7298 20.4839 21.2739 19.6767 21.6451 18.7883C22.0163 17.8999 22.2074 16.9477 22.2075 15.9861C22.2069 14.0439 21.4286 12.1813 20.0436 10.8079C18.6587 9.43449 16.7805 8.66253 14.8217 8.66171H14.8225ZM14.8046 23.9999C10.3402 24.0207 6.66675 20.4345 6.66675 16.0694C6.66675 11.2993 10.3402 7.99923 14.8046 8H16.8969C21.3061 8 25.3334 11.2978 25.3334 16.0694C25.3334 20.433 21.3076 23.9999 16.8961 23.9999"
      fill="#0079BE"
    />
  </svg>
);
export default SVGComponent;
